/**
 * @file request
 * @author fengpan
 */

import _ from 'lodash';
import axios, { AxiosRequestConfig } from 'axios';

export default function (host: string, path: string, reqObj: AxiosRequestConfig = Object.create(null)) {
    host = import.meta.env.MODE === 'development' ? '' : host;
    reqObj = _.assignIn({}, reqObj);
    return new Promise((resolve, reject) => {
        axios({
            ...reqObj,
            // 没有指定url用apimap中配置url，有指定则使用指定url，解决path传参问题
            url: !!reqObj.url ? host + reqObj.url : host + path
        })
            .then(res => {
                // TODO 隐藏loading
                res.data ? resolve(res.data) : resolve(res);
            })
            .catch(err => {
                // TODO 隐藏loading
                console.log(err);
                reject('netErr');
            });
    });
}
